import { ISelectData } from 'components/atoms/SelectComponent';

import { ETypMatky } from 'enums/lei/leiDataEnums';

export const leiTypFonduSelect: ISelectData[] = [
    {
        labelcz: 'LEI_IS_FUND_MANAGED_BY_SELECT',
        value: ETypMatky.IS_FUND_MANAGED_BY
    },
    {
        labelcz: 'LEI_IS_SUBFUND_OF_SELECT',
        value: ETypMatky.IS_SUBFUND_OF
    },
    {
        labelcz: 'LEI_IS_FEEDER_TO_SELECT',
        value: ETypMatky.IS_FEEDER_TO
    }
];
